<template>
  <base-dialog
    v-model="localValue"
    :show-cancel="false"
    :show-confirm="true"
    confirm-label="Close"
    :hide-close-button="true"
    confirm-button-class="base-dialog__primary-btn"
    @confirm="$emit('close')"
    persistent
  >
    <div class="text-center">
      <q-icon name="check_circle" size="48px" color="positive" class="q-mb-md" />
      <p class="text-center upgrade-success-dialog__text">Your subscription has been upgraded. You now have access to all premium features.</p>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog.vue';

export default {
  name: 'UpgradeSuccessDialog',
  components: {
    BaseDialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.upgrade-success-dialog {
  &__text {
    @include inter-font($size: 18px, $bolded: true, $color: var(--main-text-color));
    margin: 0;
  }
}
</style>
